import React, {Component} from "react";
import {Map, MapMarker} from "react-kakao-maps-sdk";

class KakaoMap extends Component{

    render(){
        const rootStore = this.props.rootStore;

        return(
            <div className={"map"}>
            {
                //(rootStore.viewStore.getKakaoMapLat)?
                (rootStore.viewStore.getKakaoMapLat.length > 0 && rootStore.viewStore.getKakaoMapLng > 0) ?
                    <Map
                        center={{ lat: rootStore.viewStore.getKakaoMapLat, lng: rootStore.viewStore.getKakaoMapLng }}
                        style={{ width: "100%", height: "316px" }}
                    >
                        <MapMarker position={{ lat: rootStore.viewStore.getKakaoMapLat, lng: rootStore.viewStore.getKakaoMapLng }}>
                        </MapMarker>
                    </Map>
                    :null
            }
            </div>
        )
    }
}

export default KakaoMap;